import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { CaseTypeRepository } from '../../../infrastructure/repositories/case-type.repository';
import { CaseTypeState } from '../../states/case-type.state';
import { ToggleCaseTypeActiveResult } from './toggle-case-type-active.result';

@Injectable({ providedIn: 'root' })
export class ToggleCaseTypeActiveUseCase {
  private readonly repository = inject(CaseTypeRepository);
  private readonly state = inject(CaseTypeState);

  public execute(id: string, isActive: boolean): Observable<ToggleCaseTypeActiveResult> {
    this.state.setSavingCaseTypeStatus(true);
    this.state.clearError();

    return this.repository.toggleCaseTypeActive(id, isActive).pipe(
      map(() => {
        const caseType = this.state.caseTypes().find((ct) => ct.id === id);
        if (caseType) {
          this.state.updateCaseType({ ...caseType, isActive });
        }
        return { success: true };
      }),
      catchError((error) => {
        this.state.setError(error?.error?.message || error?.message || 'Failed to toggle case type status');
        throw error;
      }),
      finalize(() => this.state.setSavingCaseTypeStatus(false))
    );
  }
}
